import { render, staticRenderFns } from "./dataAnalysis.vue?vue&type=template&id=f2e02a2a&scoped=true&"
import script from "./dataAnalysis.vue?vue&type=script&lang=js&"
export * from "./dataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalysis.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dataAnalysis.vue?vue&type=style&index=1&id=f2e02a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e02a2a",
  null
  
)

export default component.exports